export type DestroyFile = (
  feedId: string,
  fileId: number
) => Promise<Record<string, never>>
